function createPlaylistClassSelect(){
    createSelect2Single('.js-playlist-class-field-wrapper', playlistCreateClassData, 'Select');
}
function createPlaylistGenderSelect(){
    createSelect2Single('.js-playlist-gender-field-wrapper', playlistCreateGenderData, 'Select');
}
function createPlaylistTeamSelect(){
    createSelect2Single('.js-playlist-team-field-wrapper', playlistCreateTeamData, 'Select');
}
function createPlaylistSelect(){
    createSelect2Single('.js-playlist-select-field-wrapper', existingPlayListsData, 'Select Playlist');
}

runIfElementExist(createPlaylistClassSelect, '.js-playlist-class-field-wrapper');
runIfElementExist(createPlaylistGenderSelect, '.js-playlist-gender-field-wrapper');
runIfElementExist(createPlaylistTeamSelect, '.js-playlist-team-field-wrapper');
runIfElementExist(createPlaylistSelect, '.js-playlist-select-field-wrapper');
